import moment from 'moment';
import {get, map, merge} from 'lodash';
import * as utils from "./utils";
import {edit} from './sample';
import i18n from 'src/i18n/index';
import * as Member from './membership';
import {inlineSchema} from './utils';
import debug from 'src/debug';

export function title(model) {
  return model ? moment(get(model, 'created_at')).format('YYYY-MM-DD HH:mm:ss') : i18n.s('schema.systemconfig');
}

export const columns = utils.columnsFn({
  systemconfig_id: {type: 'id'},
  status: {type: 'select', items: ['status.active', 'status.inactive']},
  type: {type: 'string'},
  updated_at: {type: 'datetime'},
  last_updated_by: {type: 'schema', schema: Member, external: true},
  config: {
    type: 'schema', schema: inlineSchema({
      app_name: {type: 'string'},
      log_write_requests: {type: 'checkbox'},
      dev_secret: {type: 'string'},
    }),
  },
  selection: {
    type: 'schema', schema: inlineSchema({
      areas: {
        type: 'array', add: true, delete: true, itemType: {
          type: 'schema', schema: merge(inlineSchema({
            id: {type: 'string', required: true},
            area: {type: 'i18n', itemType: {type: 'string'}},
          }), {
            title(model) {
              return i18n.nn`${i18n.S(model.area)} (${model.id})`;
            },
          }),
        },
      },
      district_area_fee: {
        type: 'array', add: true, delete: true, itemType: {
          type: 'schema', schema: merge(inlineSchema({
            id: {type: 'string', required: true},
            extra_fee: {type: 'number', min: 0},
            caregiver_commission: {type: 'number', min: 0},
            area: {
              type: 'select', items() {
                return map(get(this.rootModel, 'selection.areas', []), x => ({value: x.id, label: i18n.S(x.area)}));
              },
            },
            location: {type: 'i18n', itemType: {type: 'string'}},
          }), {
            title(model) {
              return i18n.nn`${i18n.S(model.location)} (${model.id}, $${model.extra_fee})`;
            },
          }),
        },
      },
      special_dates: {
        type: 'array', add: true, delete: true, itemType: {
          type: 'schema', schema: merge(inlineSchema({
            "details.title": {type: 'string'},
            "ratio": {type: 'number', default: 1},
            "date": {type: 'date'},
          }), {
            title(model) {
              return i18n.nn`${get(model, 'details.title')} (${moment(model.date).format('YYYY-MM-DD')})`;
            },
          }),
        },
      },
    }),
  },
  versions: {
    type: 'schema',
    schema: inlineSchema({
      client: {
        type: 'array', add: true, delete: true, min: 1,
        itemType: {
          type: 'schema', schema: merge(inlineSchema({
            version: {type: 'string'},
            compulsory: {type: 'boolean'},
            updated_at: {type: 'datetime'},
          }), {
            title(model) {
              return i18n.nn`${model.version} ${model.compulsory ? i18n.fr('label_compulsory') : ''}`;
            },
          }),
        },
      },
      caregiver: {
        type: 'array', add: true, delete: true, min: 1,
        itemType: {
          type: 'schema', schema: merge(inlineSchema({
            version: {type: 'string'},
            compulsory: {type: 'boolean'},
            updated_at: {type: 'datetime'},
          }), {
            title(model) {
              return i18n.nn`${model.version} ${model.compulsory ? i18n.fr('label_compulsory') : ''}`;
            },
          }),
        },
      },

    }),
  },
  feedback: {
    type: 'schema',
    schema: inlineSchema({
      client_questions: {
        type: 'array', add: debug.DEBUG, delete: debug.DEBUG,
        itemType: {
          type: 'schema', schema: inlineSchema({
            question: {type: 'i18n', itemType: {type: 'string'}},
            // type: {type: 'select', items: ['rating', 'checkbox']},
            ratio: {type: 'number'},
          }),
        },
      },
      caregiver_questions: {
        type: 'array', add: debug.DEBUG, delete: debug.DEBUG,
        itemType: {
          type: 'schema', schema: inlineSchema({
            question: {type: 'i18n', itemType: {type: 'string'}},
            // type: {type: 'select', items: ['rating', 'checkbox']},
            ratio: {type: 'number'},
          }),
        },
      },
      adminToClient_questions: {
        type: 'array', add: debug.DEBUG, delete: debug.DEBUG,
        itemType: {
          type: 'schema', schema: inlineSchema({
            question: {type: 'i18n', itemType: {type: 'string'}},
            // type: {type: 'select', items: ['rating', 'checkbox']},
            ratio: {type: 'number'},
          }),
        },
      },
      adminToCaregiver_questions: {
        type: 'array', add: debug.DEBUG, delete: debug.DEBUG,
        itemType: {
          type: 'schema', schema: inlineSchema({
            question: {type: 'i18n', itemType: {type: 'string'}},
            // type: {type: 'select', items: ['rating', 'checkbox']},
            ratio: {type: 'number'},
          }),
        },
      },
    }),
  },
  app_terms: {
    label: 'Purchase Terms',
    type: 'schema',
    schema: inlineSchema({
      client: {
        type: 'i18n', itemType: {type: 'text'},
      },
      caregiver: {
        type: 'i18n', itemType: {type: 'text'},
      },
    }),
  },
});

export const list = utils.listFn('getSystemconfigs');
export const view = utils.viewFn('/admin/systemconfigs/:id');
export const read = utils.readFn('getSystemconfigById', 'systemconfig_id');

export {edit};

export function formActions(model, schema, readonly) {
  let temp = [];
  if (!readonly) {
    temp.push({
      label: i18n.fr('action.save') + ' [Ctrl+Enter]',
      class: 'btn-success',
      validation: true,
      trigger: e => (e.metaKey || e.ctrlKey) && e.keyCode === 13,
      action: utils.updateFn('updateSystemconfig', 'systemconfig_id', [
        'config',
        'selection',
        'versions',
        'feedback',
        'app_terms',
      ]),
    });
  }
  temp.push(utils.formActions.back);
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/systemconfig.js